import { render, staticRenderFns } from "./file-upload-picker.vue?vue&type=template&id=13675c2b&"
import script from "./file-upload-picker.vue?vue&type=script&lang=js&"
export * from "./file-upload-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports